import { StyledProps } from '@front10';
import React from 'react';
import Box from '../../../elements/Box';
import FareItemDepartureInfo from './FareItemDepartureInfo';
import FareItemReturnInfo from './FareItemReturnInfo';
import Separator from './Separator';

interface Props {
  showDepartureInfo?: boolean;
  showReturnInfo?: boolean;
  layout?: 'inline' | 'column';
  data: Pick<FareItem, 'formattedDepartureDate' | 'formattedReturnDate'>;
  fareItemDepartureInfo?: StyledProps;
  fareItemReturnInfo?: StyledProps;
  separatorDatesProps?: React.ComponentPropsWithoutRef<typeof Separator>;
}

export type FareItemDatesInfoProps = StyledProps<Props>;

export default function FareItemDatesInfo({
  showDepartureInfo = true,
  showReturnInfo = true,
  fareItemDepartureInfo = {},
  fareItemReturnInfo = {},
  separatorDatesProps = {},
  layout = 'inline',
  data,
  ...styles
}: FareItemDatesInfoProps) {
  const showSeparator =
    showDepartureInfo && showReturnInfo && data.formattedDepartureDate && data.formattedReturnDate;
  return showDepartureInfo || showReturnInfo ? (
    <Box {...styles}>
      {/* FareItemDepartureInfo */}
      {showDepartureInfo && fareItemDepartureInfo && (
        <FareItemDepartureInfo {...fareItemDepartureInfo} {...data} />
      )}
      {/* Separator */}
      {layout === 'inline' && showSeparator && <Separator floatLeft {...separatorDatesProps} />}
      {layout === 'column' && showSeparator && <br />}
      {/* FareItemReturnInfo */}
      {showReturnInfo && fareItemReturnInfo && (
        <FareItemReturnInfo {...fareItemReturnInfo} {...data} />
      )}
    </Box>
  ) : null;
}
